import {
  BorderRadius8,
  Box,
  GreyGrey30,
  InputSelectControlField
} from '@sequencehq/core-components'
import { IntegrationCustomerEmptyState } from './IntegrationCustomerEmptyState'
import { SelectableCustomer } from './integrationCustomer.types'

const EMPTY_STATE_HEIGHT_PX = 200

export const IntegrationCustomerSelect = (props: {
  customers: SelectableCustomer[]
  value: string
  onChange: (customerId: string) => void
  label?: string
  integrationName: string
  unfilteredCustomerCount: number
  allCustomersLinked: boolean
  'data-testid': string
}) => {
  const dataTestId = props['data-testid']

  if (props.customers.length === 0) {
    return (
      <Box
        height={`${EMPTY_STATE_HEIGHT_PX}px`}
        border={`1px solid ${GreyGrey30}`}
        borderRadius={BorderRadius8}
        data-testid={`${dataTestId}.list`}
      >
        <IntegrationCustomerEmptyState
          action="link"
          unfilteredCustomerCount={props.unfilteredCustomerCount}
          allCustomersLinked={props.allCustomersLinked}
          integrationName={props.integrationName}
          data-testid={`${dataTestId}.emptyState`}
        />
      </Box>
    )
  }

  return (
    <InputSelectControlField
      label={props.label}
      data-testid={dataTestId}
      placeholder={`Select ${props.integrationName} customer`}
      value={props.value}
      onChange={props.onChange}
      options={props.customers.map(customer => ({
        label: customer.name,
        value: customer.id
      }))}
    />
  )
}
